import {
  IUpdateBasketClientDTO,
  UPDATE_BASKET,
} from '@common/interfaces/eventEntries/UpdateBasketEvent';
import {
  IStartCheckoutClientDTO,
  START_CHECKOUT,
} from '@common/interfaces/eventEntries/StartCheckoutEvent';
import { trpc } from '@portal/trpc/bare';

export const analyticsEventsDelegate = {
  updateBasket: async (dto: IUpdateBasketClientDTO) => {
    await trpc.salesforce.ingestAnalyticsEvent.mutate({
      entryType: UPDATE_BASKET,
      entry: dto,
    });
  },

  startCheckout: async (dto: IStartCheckoutClientDTO) => {
    await trpc.salesforce.ingestAnalyticsEvent.mutate({
      entryType: START_CHECKOUT,
      entry: dto,
    });
  },
};
